module.exports = __webpack_public_path__ + "static/media/twitter.02f1f59d.png";